// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Qd7d5","loadingSpinner":"App_loadingSpinner__JIr5Y"};